var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"custom-button",class:{
    'is-transparent': _vm.transparent,
    'is-dark': _vm.dark,
    'with-border': _vm.withBorder,
    'is-hover': _vm.hover,
    'is-selected': _vm.selected,
    'round': _vm.round,
    'is-disabled': _vm.disabled,
  },attrs:{"type":"button","tabindex":"0"},on:{"click":function($event){$event.stopPropagation();!_vm.disabled ? _vm.$emit('click') : null},"mouseover":function($event){!_vm.disabled ?_vm.$emit('mouseover') : null},"mouseleave":function($event){!_vm.disabled ? _vm.$emit('mouseleave') : null}}},[_c('span',{staticClass:"custom-button-effect",style:(_vm.bgStyle)}),_c('span',{staticClass:"custom-button-content",style:(_vm.colorStyle)},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }